// Close mobile navbar after clicking a link
document.querySelectorAll('#mainNav .nav-link, #mainNav .btn').forEach(function (link) {
    link.addEventListener('click', function () {
        var collapse = document.getElementById('mainNav');
        if (collapse && collapse.classList.contains('show')) {
            new bootstrap.Collapse(collapse).hide();
        }
    });
});

// Lightbox for work images
(function () {
    var lightbox = document.getElementById('lightbox');
    if (!lightbox) return;
    var lbImg     = lightbox.querySelector('.lightbox-img');
    var lbCaption = lightbox.querySelector('.lightbox-caption');
    var lbClose   = lightbox.querySelector('.lightbox-close');

    function open(full, caption) {
        lbImg.src = full;
        lbImg.alt = caption;
        lbCaption.textContent = caption;
        lightbox.classList.add('open');
        lightbox.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
    }
    function close() {
        lightbox.classList.remove('open');
        lightbox.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        lbImg.src = '';
    }

    document.querySelectorAll('.work-thumb-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
            open(btn.getAttribute('data-full'), btn.getAttribute('data-caption'));
        });
    });
    lbClose.addEventListener('click', close);
    lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox) close();
    });
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && lightbox.classList.contains('open')) close();
    });
})();

// Add shadow to navbar on scroll
var nav = document.querySelector('.site-nav');
window.addEventListener('scroll', function () {
    if (!nav) return;
    if (window.scrollY > 20) {
        nav.style.boxShadow = '0 8px 30px rgba(0,0,0,.4)';
    } else {
        nav.style.boxShadow = 'none';
    }
});
